import * as angular from "angular";
import {IController} from "angular";

export class SkillsTableCtrl implements IController {

  skills: any;
  onEdit: Function;
  onActiveChange: Function;

  /* @ngInject */
  constructor() {}

}
angular
  .module('bringoz.admin.skills')
  .component('skillsTable', {
    bindings: {
      skills: '<',
      onEdit: '&',
      onActiveChange: '&'
    },
    template: require('./skills-table.html').default,
    controller: SkillsTableCtrl
  });
